var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center mt-5"},[_c('h1',{staticClass:"notFound-big"},[_vm._v("Errore 404 "),_c('br'),_vm._v(" Pagina non trovata")])])
}]

export { render, staticRenderFns }